<template>
  <div class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">总部活动物料：</div>
          <div class="content">
            <el-input v-model="form.activityName" placeholder="请输入"></el-input>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addBtn">添加</el-button>
    </div>
    <commonTable ref="hqActivityManagementTable" />
    <addMaterialDialog
      :row-data="rowData"
      :add-hq-activity-visible="addHqActivityVisible"
      @addHqActivitySubHandle="addHqActivitySubHandle"
      @editHqActivitySubHandle="editHqActivitySubHandle"
      @dialogCloseHandle="dialogCloseHandle"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addMaterialDialog from './addMaterialDialog';
import { templateActivityApi, hqActivityManagementApi } from '../../service';
import Cookies from 'js-cookie';
export default {
  data () {
    return {
      form: {
      },
      yearList: [],
      stateList: [
        {
          label: '全部'
        },
        {
          label: '启用',
          val: 1
        },
        {
          label: '禁用',
          val: 0
        }
      ],
      addHqActivityVisible: false,
      rowData: {}
    };
  },
  components: {
    commonTable,
    addMaterialDialog
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    statHandle (row) {
      let params = {
        id: row.id,
        stat: row.stat
      };
      this.$store.commit('setSubPageLoading', true);
      hqActivityManagementApi.hqActivityUpdate(params).then(res => {
        if (res.status === '200') {
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    deleteHandle (row) {
      this.$confirm('确定删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        hqActivityManagementApi.hqActivityDel(row.id).then(res => {
          if (res.status === '200') {
            this.loadTable();
            this.$message.success('删除成功');
          }
        });
      }).catch(() => {

      });
    },
    editHqActivitySubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      hqActivityManagementApi.hqActivityUpdate(data).then(res => {
        if (res.status === '200') {
          this.$message.success('编辑成功');
          this.addHqActivityVisible = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    materialSunHandle (data) {
      templateActivityApi.getTicketEncrypt().then(res => {
        if (res.status === '200') {
          const ticket =  window.encodeURIComponent(res.data);
          const templateName = window.encodeURIComponent(data.activityNameEncrypt);
          const templateId = window.encodeURIComponent(data.idEncrypt);
          // const datas = window.encodeURIComponent(this.userInfo.emailEncrypt);
          this.$confirm('物料状态是否更新？')
          .then(_ => {
            this.loadTable();
          })
          .catch(_ => {
            this.loadTable();
          });
          window.open(`${window._env_.VUE_APP_HT_URL}/rjTemplate/rjEventTemplateConfig?templateName=${templateName}&templateId=${templateId}&data=${ticket}`);
        }
      })
    },
    addHqActivitySubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      hqActivityManagementApi.hqActivityAdd(data).then(res => {
        if (res.status === '200') {
          this.$message.success('添加成功');
          this.addHqActivityVisible = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    dialogCloseHandle () {
      this.rowData = {};
      this.addHqActivityVisible = false;
    },
    addBtn () {
      this.addHqActivityVisible = true;
    },
    editHandlen (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addHqActivityVisible = true;
    },
    reset () {
      this.form = {
      };
      this.searchBtn();
    },
    searchBtn () {
      const params = {
        ...this.form,
        htType: 1
      };
      this.$refs.hqActivityManagementTable.pageData.pageNum = 1;
      this.$refs.hqActivityManagementTable.getTableData({ url: '/headquarter_activity/list', params });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('总部活动物料')
          ._width('26%')
          ._data('activityName')
      );
      tableRow.push(
        new TableColumns()
          ._title('更新时间')
          ._width('8%')
          ._data('updateTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('更新人')
          ._width('8%')
          ._data('updateUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('物料状态')
          ._width('6%')
          ._data('materialStat')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  { row.materialStat ? '已配置' : '未配置' }
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('状态')
          ._width('6%')
          ._data('stat')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  {<el-switch v-model={row.stat} active-value={1} inactive-value={0} onChange={() => {this.statHandle(row);;}}>
                  </el-switch>}
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('12%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.editHandlen(row); }}>
                    编辑
                  </el-button>
                  <el-button type="text" onClick={() => { this.materialSunHandle(row); }}>
                    物料配置
                  </el-button>
                  <el-button type="text" onClick={() => { this.deleteHandle(row); }}>
                    删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      const params = {
        ...this.form,
        htType: 1
      };
      this.$refs.hqActivityManagementTable.setColumn(column);
      this.$refs.hqActivityManagementTable.loadTable({ url: '/headquarter_activity/list', listKey: 'list', params });
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>

<style scoped>
.common_button {
  margin-bottom: 16px;
}
</style>
